export default "__VITE_ASSET__B9UDfR5P__";